var Handlebars = require('C:/Users/sofdam/Work/direktupphandlingen-2019/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"alert alert-dotted alert-green\">\n	<div class=\"t-rte\">\n		<p>Tack för att du återkopplar till oss!</p>\n	</div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./templates/page-feedback-feedback.hbs
// module id = 50
// module chunks = 9